module.exports = __webpack_public_path__ + "img/employee_calendar.5da07100.svg";